<div class="app-content ">
    <router-outlet></router-outlet>
    <app-toast-container></app-toast-container>
</div>

<TabBar class="fixed-bottom w-100" />